module.exports = __webpack_public_path__ + "static/viti-observation-ef680ce07aec5e27ba7a8c3407921166.png";